import { serviciosContenido } from "@/data/servicios-contenido";

const SITE = "https://agenciaseoevolution.com";

/**
 * Genera los scripts JSON-LD (Service + FAQPage + BreadcrumbList) para
 * una página de servicio, a partir del contenido visible en la página.
 */
export function serviceSchemaScripts(slug: string) {
  const content = serviciosContenido[slug];
  if (!content) return [];

  const url = `${SITE}${content.path}`;

  const service = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: content.name,
    description: content.description,
    url,
    serviceType: content.name,
    provider: {
      "@type": "Organization",
      name: "SEOEVOLUTION",
      url: SITE,
      telephone: "+34910626684",
      email: "contacto@agenciaseoevolution.com",
    },
    areaServed: { "@type": "Country", name: "España" },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: `Entregables de ${content.name}`,
      itemListElement: content.deliverables.items.map((item) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: item.title, description: item.description },
      })),
    },
  };

  const faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: content.faqs.items.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };

  const breadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Inicio", item: SITE },
      { "@type": "ListItem", position: 2, name: "Servicios", item: `${SITE}/mas-servicios` },
      { "@type": "ListItem", position: 3, name: content.name, item: url },
    ],
  };

  return [service, faq, breadcrumb].map((schema) => ({
    type: "application/ld+json",
    children: JSON.stringify(schema),
  }));
}
